import { useState, useEffect } from 'react';

import { SCRIPT_ID, SCRIPT_URL } from './constants';

const injectTurnstileScript = () => {
  const scriptSrc = `${SCRIPT_URL}?render=explicit`;

  // Prevent duplicate script injection with the same src
  if (
    window.turnstile ||
    document.querySelector(`script[src="${scriptSrc}"]`)
  ) {
    return;
  }

  const script = document.createElement('script');

  script.src = scriptSrc;
  script.id = SCRIPT_ID;
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);
};

const ensureTurnstile = () => {
  injectTurnstileScript();

  const retries = 50;
  const interval = 100;
  let attempt = 0;

  return new Promise<void>((resolve, reject) => {
    const check = () => {
      //
      if (attempt++ > retries) {
        reject();
      }

      if (window.turnstile) {
        resolve();
      } else {
        setTimeout(check, interval);
      }
    };

    check();
  });
};

export const useTurnstile = () => {
  const [loaded, setLoaded] = useState(!!window.turnstile);

  useEffect(() => {
    (async () => {
      try {
        await ensureTurnstile();

        setLoaded(true);
      } catch (_error) {
        setLoaded(false);
      }
    })();
  }, []);

  return { loaded };
};
